@if (loading()) {
	<lb-loader message="Loading enrollment..."></lb-loader>
} @else if (enrollmentDetail(); as enrollmentDetail) {
	<lb-enrollment-notifications [enrollment]="enrollmentDetail" [lessons]="lessons()" [lessonsLoading]="lessonsLoading()"></lb-enrollment-notifications>

	<lb-two-column-page-layout>
		<div two-column-page-layout-left-content class="column-content">
			<md-content-box class="content-box">
				<md-icon icon="untitled-ui/users/user-01"></md-icon>

				<div class="user-section">
					<span class="md-text-sm-medium">
						{{ userView !== 'instructor' ? 'Instructor' : 'Learner' }}
					</span>
					<div class="user" [class.user--clickable]="canOpenUserDetail()" (click)="openUserDetail()">
						@if (viewingUser(); as user) {
							<lb-user-icon [userID]="user.userID"></lb-user-icon>
							<div class="user__info">
								<div class="user__name-row">
									<span class="md-text-sm-medium user__name">{{ user.fullName }}</span>
									@for (tag of learnerTags(); track tag.userTagTypeID) {
										<md-tag [type]="tag.tagColor ?? 'warning'">{{ tag.tagTypeName }}</md-tag>
									}
								</div>

								<span class="md-text-sm-regular">
									{{ user.email }}
									<lb-copy-to-clipboard [textToCopy]="user.email" [showConfirmation]="true"></lb-copy-to-clipboard>
								</span>
							</div>
						} @else {
							<lb-no-instructor></lb-no-instructor>
						}
					</div>
				</div>

				<div class="content-row">
					<span class="md-text-sm-medium">Status</span>
					<lb-enrollment-tag
						[enrollmentStatus]="enrollmentDetail?.enrollmentStatusName"
						[enrollmentStatusID]="enrollmentDetail?.enrollmentStatusID"
						[isLearner]="userView === 'learner'"
					></lb-enrollment-tag>
				</div>
			</md-content-box>

			<md-content-box class="content-box">
				<md-icon icon="untitled-ui/education/book-open-01"></md-icon>

				<div class="content-row">
					<span class="md-text-sm-medium">Program</span>
					<lb-program-type-tag [programType]="programType()" [program]="programName()" variant="modern" [showFullName]="true"></lb-program-type-tag>
				</div>

				<div class="content-row">
					<span class="md-text-sm-medium">Language</span>
					<span class="md-text-sm-regular">
						{{ enrollmentDetail?.languageName }}
						<md-tag>Level {{ enrollmentDetail?.languageLevels }}</md-tag>
					</span>
				</div>
			</md-content-box>

			<md-content-box class="content-box">
				<md-icon icon="untitled-ui/time/calendar"></md-icon>

				<div class="content-row">
					<span class="md-text-sm-medium">Must Start By</span>
					<span class="md-text-sm-regular">
						{{ mustStartBy() ?? '-' }}
					</span>
				</div>

				<div class="content-row">
					<span class="md-text-sm-medium">First Lesson Date</span>
					<span class="md-text-sm-regular">
						{{ startDate() ?? '-' }}
					</span>
				</div>

				<div class="content-row">
					<span class="md-text-sm-medium">Last Lesson Date</span>
					<span class="md-text-sm-regular">
						{{ endDate() ?? '-' }}
					</span>
				</div>

				<div class="content-row">
					<span class="md-text-sm-medium">Program Expiration</span>
					<span class="md-text-sm-regular">
						{{ programCompletionDate() ?? '-' }}
					</span>
				</div>
			</md-content-box>

			<md-content-box class="content-box">
				<md-icon icon="untitled-ui/time/clock"></md-icon>

				<div class="content-row">
					<span class="md-text-sm-medium">Lesson Times</span>
					<div class="lesson-times">
						@if (timeSlotSelections().length > 0) {
							@for (selection of timeSlotSelections(); track $index) {
								<div class="schedule">
									<md-tag>{{ selection.day.substring(0, 3) }}, {{ selection.displayValue }}</md-tag>
								</div>
							}
						}
					</div>
				</div>

				<div class="content-row">
					<span class="md-text-sm-medium">Lesson Frequency</span>
					<span class="md-text-sm-regular">
						@if (enrollmentDetail?.lessonFrequency; as frequency) {
							{{ frequency }} lessons / week
						} @else {
							<span>-</span>
						}
					</span>
				</div>
				<div class="content-row">
					<span class="md-text-sm-medium">Time zone</span>
					<span class="md-text-sm-regular">
						{{ learnerTimeZone() ?? '-' }}
					</span>
				</div>
			</md-content-box>
		</div>

		<div two-column-page-layout-right-content class="column-content">
			<md-content-box class="content-box">
				<md-icon icon="untitled-ui/charts/horizontal-bar-chart-01"></md-icon>

				<div class="progress full-width">
					@if (programSummary()) {
						<span class="md-text-sm-medium">Program Completion</span>
						<lb-program-completion-summary [program]="programSummary()!"></lb-program-completion-summary>
					}

					@if (semesterProjectProgress().length > 0) {
						<div class="project-progress">
							<span class="md-text-sm-medium">Project Progress</span>
							@for (semesterProgress of semesterProjectProgress(); track semesterProgress.semesterID) {
								<div class="project-progress__row">
									@if (semesterProjectProgress().length > 1) {
										<span class="project-progress__semester-label">{{ semesterProgress.label }}</span>
									}
									<div class="project-progress__bar-row">
										<md-tag type="tertiary">{{ semesterProgress.progressLabel }}</md-tag>
										<md-progress-bar [progress]="semesterProgress.percent" [height]="16"></md-progress-bar>
									</div>
								</div>
							}
						</div>
					}
				</div>
			</md-content-box>

			@if (gradingTemplate()?.isGraded) {
				<lb-final-grades-summary [enrollmentDetail]="enrollmentDetail" [gradingTemplate]="gradingTemplate()!"></lb-final-grades-summary>
			}
		</div>
	</lb-two-column-page-layout>
}
